var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "airport_icon",
    "data-name": "airport icon",
    transform: "translate(-346 -290)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 24,
    height: 24,
    transform: "translate(346 290)",
    fill: "#19bc9c",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(348 297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M-1456.728,2578.847h2.135a.324.324,0,0,1,.277.156l3.9,6.468a.321.321,0,0,1,0,.325.323.323,0,0,1-.282.165h-3.038a.323.323,0,0,1-.293-.187l-3-6.467A.323.323,0,0,1-1457,2579,.323.323,0,0,1-1456.728,2578.847Zm1.953.647h-1.447l2.7,5.82h2.26Z",
    transform: "translate(1462.077 -2578.847)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M-1465.038,2591.748a3.173,3.173,0,0,1-.992-.161,2.908,2.908,0,0,1-1.843-1.9c-.729-2.062-1.294-3.751-1.3-3.767a.324.324,0,0,1,.044-.292.322.322,0,0,1,.262-.135h2.15a.323.323,0,0,1,.294.19l1.235,2.747,2.972-.464a.323.323,0,0,1,.368.27.322.322,0,0,1-.269.369l-3.215.5a.322.322,0,0,1-.343-.187l-1.251-2.781h-1.492c.213.629.643,1.888,1.152,3.331a2.286,2.286,0,0,0,2.387,1.619l.039,0h14.457a.644.644,0,0,0,.494-.264c.079-.148.139-.522-.355-1.349a3.246,3.246,0,0,0-2.224-1.481,5.087,5.087,0,0,0-1.453-.1l-3.584.386a.324.324,0,0,1-.355-.288.323.323,0,0,1,.286-.356l3.583-.385a5.652,5.652,0,0,1,1.638.106,3.922,3.922,0,0,1,2.663,1.786c.5.843.626,1.514.366,1.993a1.3,1.3,0,0,1-1.039.6h-14.461C-1464.857,2591.742-1464.933,2591.748-1465.038,2591.748Z",
    transform: "translate(1469.189 -2582.646)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    d: "M1.078.647a.431.431,0,1,0,.431.431A.432.432,0,0,0,1.078.647m0-.647A1.078,1.078,0,1,1,0,1.078,1.078,1.078,0,0,1,1.078,0Z",
    transform: "translate(9.352 8.663)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    d: "M1.078.647a.431.431,0,1,0,.431.431A.432.432,0,0,0,1.078.647m0-.647A1.078,1.078,0,1,1,0,1.078,1.078,1.078,0,0,1,1.078,0Z",
    transform: "translate(12.362 8.663)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M-1429.923,2593.328h-3.018a.323.323,0,0,1-.323-.323.323.323,0,0,1,.323-.324h3.018a.323.323,0,0,1,.323.324A.323.323,0,0,1-1429.923,2593.328Z",
    transform: "translate(1448.738 -2586.731)",
    fill: "#19bc9c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportIcon);
export default __webpack_public_path__ + "static/media/airport_icon.84ace7ee42432f1339e128988d6beafa.svg";
export { ForwardRef as ReactComponent };